(function(){
function init(){
  var io=new IntersectionObserver(function(es){es.forEach(function(e){
    var v=e.target.querySelector('video');
    if(e.isIntersecting){e.target.classList.add('is-in');if(v){if(v.preload==='none'){v.preload='auto'}v.play().catch(function(){})}}
    else if(v){v.pause()}
  })},{threshold:.35});
  document.querySelectorAll('[data-hw2-row]').forEach(function(r){if(r.__h)return;r.__h=1;io.observe(r)});
}
document.addEventListener('click',function(e){var b=e.target.closest('[data-hw2-copy]');if(!b)return;var t=b.parentNode.querySelector('[data-hw2-phrase]').textContent.trim();
  function done(){b.textContent='Copied';setTimeout(function(){b.textContent='Copy'},1800)}
  if(navigator.clipboard&&navigator.clipboard.writeText)navigator.clipboard.writeText(t).then(done,function(){});else{var a=document.createElement('textarea');a.value=t;document.body.appendChild(a);a.select();try{document.execCommand('copy');done()}catch(x){}document.body.removeChild(a)}});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();
